module.exports = __webpack_public_path__ + "img/aeroland-client-logo-11-hover.841ced22.png";